





























































































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component({})
export default class AppListSelector extends Vue {
  @Prop({ type: Array }) readonly value!: number[];
  @Prop(String) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: [Number, String], default: 289 }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  @Prop({ type: Array }) readonly items!: string[];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  model: number[] = [];

  options: any[] = [];

  get selected () {
    return this.options.filter((opt) => opt.selected)
  }

  get unSelected () {
    return this.options.filter((opt) => !opt.selected)
  }

  mounted () {
    const options: any = []

    for (const [i, v] of this.items.entries()) {
      options.push({
        index: i,
        selected: false,
        value: v
      })
    }

    this.value.map((val) => {
      options[val].selected = true
    })

    this.options = options
    this.model = this.value
  }

  @Watch('items', { deep: true })
  onItemsChanged (val: any) {
    const options: any = []
    for (const [i, v] of val.entries()) {
      options.push({
        index: i,
        selected: false,
        value: v
      })
    }

    this.value.map((val) => {
      options[val].selected = true
    })

    this.options = options
  }

  @Emit('input')
  valueChangedHandler () {
    return this.model
  }

  addOption (index: number) {
    this.options[index].selected = true
    this.model.push(index)
    this.valueChangedHandler()
  }

  addOptionAll () {
    const { options } = this
    const model = []
    const length = options.length

    for (let i = 0; i < length; i++) {
      options[i].selected = true
      model.push(i)
    }

    this.model = model
    this.options = options
    this.valueChangedHandler()
  }

  removeOption (index: number) {
    this.options[index].selected = false
    this.model = this.$R.without([index], this.model)
    this.valueChangedHandler()
  }

  removeOptionAll () {
    const { options } = this
    const length = options.length

    for (let i = 0; i < length; i++) {
      options[i].selected = false
    }

    this.model = []
    this.options = options
    this.valueChangedHandler()
  }
}
